<br/>
<div class="container mx-auto">
    <h2>System Status</h2>
    <app-system-wide-message></app-system-wide-message>
    <ng-container *ngFor="let status of statuses['meta']">
      <div class="system-wide-message alert alert-danger alert-dismissible fade show" role="alert" *ngIf="status.realtime == false">
        <div>There was an error retrieving the real-time data, please try refreshing.</div>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </ng-container>
    <div class="row d-flex p-2 text-center">
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link" [ngClass]="{'active' : mode == 'bus'}" id="nav-bus-tab" data-toggle="tab" href="#nav-bus" role="tab" aria-controls="nav-bus" aria-selected="true">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/bus/bus-status.png">

                    </div>
                    <span class="badge">
                        Bus
                    </span>
                </a>
                <a class="nav-item nav-link" [ngClass]="{'active' : mode == 'rail'}" id="nav-rail-tab" data-toggle="tab" href="#nav-rail" role="tab" aria-controls="nav-rail" aria-selected="false">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/rail/rail-status.png">
                    </div>
                    <span class="badge">
                        Rail
                    </span>
                </a>
                <a class="nav-item nav-link d-block d-sm-none" [ngClass]="{'active' : ['subway', 'nhsl', 'cct'].includes(mode) && screen <= 575 }" id="nav-others-tab" data-toggle="tab" href="#nav-others" role="tab" aria-controls="nav-others" aria-selected="false">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/mfl/mfl-status.png">
                    </div>
                    <span class="badge">
                        Other
                    </span>
                </a>
                <a class="nav-item nav-link d-none d-sm-block" [ngClass]="{'active' : mode == 'subway' && screen > 575}" id="nav-subway-tab" data-toggle="tab" href="#nav-subway" role="tab" aria-controls="nav-subway" aria-selected="false">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/bsl/bsl-status.png">
                    </div>
                    <span class="badge">
                        Subway
                    </span>
                </a>
                <a class="nav-item nav-link d-none d-sm-block" [ngClass]="{'active' : mode == 'nhsl' && screen > 575}" id="nav-nhsl-tab" data-toggle="tab" href="#nav-nhsl" role="tab" aria-controls="nav-nhsl" aria-selected="false">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/nhsl/nhsl-status.png">
                    </div>
                    <span class="badge">
                        NHSL
                    </span>
                </a>
                <a class="nav-item nav-link" [ngClass]="{'active' : mode == 'trolley'}" id="nav-trolley-tab" data-toggle="tab" href="#nav-trolley" role="tab" aria-controls="nav-trolley" aria-selected="false">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/trolley/trolley-status.png">
                    </div>
                    <span class="badge">
                        Trolley
                    </span>
                </a>
                <a [ngClass]="{'active' : mode == 'cct' && screen > 575}" class="nav-item nav-link  d-none d-sm-block" id="nav-cct-tab" data-toggle="tab" href="#nav-cct" role="tab" aria-controls="nav-cct" aria-selected="false">
                    <div class="status-icons">
                        <img class="status-icons" src="../../../assets/images/modes/cct/cct-status.png">
                    </div>
                    <span class="badge">
                        CCT
                    </span>
                </a>
            </div>
        </nav>
    </div>

    <br/>
    <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show" [ngClass]="{'active show' : mode == 'bus'}" id="nav-bus" role="tabpanel" aria-labelledby="nav-bus-tab">
            <div>
                <div class="row mx-auto" *ngFor="let routes of statuses['bus']; index as i">
                    <div class="col-sm border-bottom route-selectable" *ngFor="let route of routes">
                      <a routerLink="/routes/status/{{route.id}}">
                        <strong> {{ route.name }} </strong>
                        <div class="d-block d-sm-none">{{ route.description }}</div>
                        <div class="route-selection-status">
                            <span [ngClass]="{'icon-inactive': route.isalert === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                            </span>
                        </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{'active show' : mode == 'rail'}" id="nav-rail" role="tabpanel" aria-labelledby="nav-rail-tab">
            <div>
                <div class="row mx-auto" *ngFor="let routes of statuses['rail']; index as i">
                    <div class="col-sm border-bottom route-selectable" *ngFor="let route of routes">
                      <a routerLink="/routes/status/{{route.id}}">
                        <strong> {{ route.name }} </strong>
                        <div class="d-block d-sm-none">{{ route.description }}</div>
                        <div class="route-selection-status">
                            <span [ngClass]="{'icon-inactive': route.isalert === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                            </span>
                        </div>
                      </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{'active show' : mode == 'subway' && screen > 575}" id="nav-subway" role="tabpanel" aria-labelledby="nav-subway-tab">
            <div>
                <div class="row mx-auto" *ngFor="let routes of statuses['subway']; index as i">
                    <div class="col-sm border-bottom route-selectable" *ngFor="let route of routes">
                      <a routerLink="/routes/status/{{route.id}}">
                        <strong> {{ route.name }} </strong>
                        <div class="d-block d-sm-none">{{ route.description }}</div>
                        <div class="route-selection-status">
                            <span [ngClass]="{'icon-inactive': route.isalert === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                            </span>
                        </div>
                      </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{'active show' : ['subway', 'nhsl', 'cct'].includes(mode) && screen <= 575 }" id="nav-others" role="tabpanel" aria-labelledby="nav-others-tab">
            <div>
                <div class="row mx-auto" *ngFor="let routes of statuses['others']; index as i">
                    <div class="col-sm border-bottom route-selectable" *ngFor="let route of routes">
                      <a routerLink="/routes/status/{{route.id}}">
                        <strong> {{ route.name }} </strong>
                        <div class="d-block d-sm-none">{{ route.description }}</div>
                        <div class="route-selection-status">
                            <span [ngClass]="{'icon-inactive': route.isalert === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                                <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                            </span>
                            <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                            </span>
                        </div>
                      </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{'active show' : mode == 'nhsl' && screen > 575}" id="nav-nhsl" role="tabpanel" aria-labelledby="nav-nhsl-tab">
            <div class="row mx-auto" *ngFor="let routes of statuses['nhsl']; index as i">
                <div class="col-sm border-bottom route-selectable" *ngFor="let route of routes">
                  <a routerLink="/routes/status/{{route.id}}">
                    <strong> {{ route.name }} </strong>
                    <div class="d-block d-sm-none">{{ route.description }}</div>
                    <div class="route-selection-status">
                        <span [ngClass]="{'icon-inactive': route.isalert === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                            <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.isdetour === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                        </span>
                    </div>
                  </a>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{'active show' : mode == 'trolley'}" id="nav-trolley" role="tabpanel" aria-labelledby="nav-trolley-tab">
            <div class="row mx-auto" *ngFor="let routes of statuses['trolley']; index as i">
                <div class="col-sm border-bottom route-selectable" *ngFor="let route of routes">
                  <a routerLink="/routes/status/{{route.id}}">
                    <strong> {{ route.name }} </strong>
                    <div class="d-block d-sm-none">{{ route.description }}</div>
                    <div class="route-selection-status">
                        <span [ngClass]="{'icon-inactive': route.isalert === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                            <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.isdetour === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                        </span>
                    </div>
                  </a>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{'active show' : mode == 'cct' && screen > 575}" id="nav-cct" role="tabpanel" aria-labelledby="nav-cct-tab">
            <div class="row mx-auto" *ngFor="let routes of statuses['cct']; index as i">
                <div class="col-sm border-bottom route-selectable" *ngFor="let route of routes" (click)="onDetail(route)">
                    <strong> {{ route.name }} </strong>
                    <div class="d-block d-sm-none">{{ route.description }}</div>
                    <div class="route-selection-status">
                        <span [ngClass]="{'icon-inactive': route.isalert === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/alert.png" *ngIf="route.issuspended == false">
                            <img class="status-icons" src="../../../assets/images/route-status/suspended.png" *ngIf="route.issuspended == true">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.isdetour === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/detour.png">
                        </span>
                        <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                            <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br/>

<app-main-footer></app-main-footer>